import { FeatureFlagsEnum } from '../../types/blp-feature-flags';
import { GreenroomState } from '../types/types';

// eslint-disable-next-line max-len
export const selectFeatureFlag = (flag: FeatureFlagsEnum) => (state: GreenroomState) => state.FeatureFlagsReducer.featureFlags[flag];

// eslint-disable-next-line max-len
export const selectFeatureFlagsLoading = (state: GreenroomState) => state.FeatureFlagsReducer.loading;
